var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"cloudCenter"}},[_c('heads')],1),_c('div',{staticClass:"model",staticStyle:{"width":"100%","height":"85%"},attrs:{"id":"domId"}})])}
var staticRenderFns = []

export { render, staticRenderFns }